import { render, staticRenderFns } from "./TimeCardForm.vue?vue&type=template&id=2c0c1f5a&scoped=true&"
import script from "./TimeCardForm.vue?vue&type=script&lang=ts&"
export * from "./TimeCardForm.vue?vue&type=script&lang=ts&"
import style0 from "./TimeCardForm.vue?vue&type=style&index=0&id=2c0c1f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c1f5a",
  null
  
)

export default component.exports